'use client'

import HGLink from '@/components/links'
import MenuButton from '@/components/menuButton'
import { Menus } from '@/entities/menus'
import { useCallback, useEffect, useRef, useState } from 'react'
import { MenuContext, useMenuContext } from './context'

export function MobileMenuContent({ data }: { data: Menus[] }) {
  const { isOpen, closeMenu } = useMenuContext()
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (!dialogRef.current) {
      return
    }

    if (isOpen) {
      dialogRef.current.showModal()
    } else {
      dialogRef.current.close()
    }
  }, [isOpen])

  function handleCloseDialog() {
    dialogRef.current?.close()
  }

  return (
    <dialog
      ref={dialogRef}
      onClose={closeMenu}
      className='backdrop:bg-black/80 w-full h-full bg-transparent max-w-full max-h-full'
    >
      <div className={'w-4/5 h-full max-w-140 bg-white px-4 py-5'}>
        <div className='flex items-center gap-x-2'>
          <MenuButton
            open
            size='small'
            className='text-primary'
            onClick={closeMenu}
          />
          <span className='font-medium'>Menu</span>
        </div>
        <ul className='mt-5'>
          {data.map((menu) => (
            <li key={menu.id}>
              <HGLink
                href={
                  String(menu.slug).startsWith('/')
                    ? menu.slug
                    : `/${menu.slug}`
                }
                aria-label={`go to ${menu.name}`}
                className='block py-2'
                activeClassName='text-primary'
                onClick={handleCloseDialog}
              >
                {menu.name}
              </HGLink>
            </li>
          ))}
        </ul>
      </div>
    </dialog>
  )
}

export function HeaderMenuButton() {
  const { openMenu } = useMenuContext()
  return <MenuButton onClick={openMenu} className='md:hidden' />
}

export function HeaderMenuContextProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [isOpen, setIsOpen] = useState(false)
  const openMenu = useCallback(() => {
    setIsOpen(true)
  }, [])
  const closeMenu = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <MenuContext.Provider value={{ isOpen, openMenu, closeMenu }}>
      {children}
    </MenuContext.Provider>
  )
}
